import React from "react";

export default function SQLServer_CAST() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CAST</h1>
      <p>This is the SQLServer_CAST component generated from the SQL JSON.</p>
    </div>
  );
}
